import ACTION_TYPES from "./type.action";

export const showLoader = () => {
  return { type: ACTION_TYPES.SHOW_LOADER};
};

export const hideLoader = () => {
  return { type: ACTION_TYPES.HIDE_LOADER };
};